
export class ComponentDetails {
  id: number;
  name: string;
  DatasourceId: number;
  RawTagName: string;
  ThresholdTypeId: number;
  condition: string;
  value: number;
  frequency: number;
  workflowTriggerTypeId: number;
  frequencyUnitId: number;
  dataSourceId: number;
  startTime: string;
  endTime: string;
  selectCollection: boolean;

  constructor() {
    this.id = 0;
    this.name = '';
    this.DatasourceId = 0;
    this.RawTagName = '';
    this.ThresholdTypeId = 0;
    this.condition = '';
    this.value = 0;
    this.frequency = 0;
    this.workflowTriggerTypeId = 0;
    this.frequencyUnitId = 0;
    this.dataSourceId = 0;
    this.startTime = "";
    this.endTime = "";
    this.selectCollection = false;
  }

}
